import { Skeleton } from '@/components/ui/skeleton';

export function EditEventSkeleton() {
  return (
    <div className="flex items-start h-full w-full">
      <div className="w-2/5 justify-end hidden h-full lg:flex p-4">
        <Skeleton className="w-96 h-4/5" />
      </div>

      <div className="flex-1 min-h-0 overflow-y-hidden p-4 w-full flex-col xl:w-4/5 flex">
        <div className="space-y-2 xl:max-w-[80%] max-w-full">
          <Skeleton className="h-48 w-full" />
          <Skeleton className="h-48 w-full" />
          <Skeleton className="h-[600px] w-full" />
        </div>
      </div>
    </div>
  );
}
